module.exports = __webpack_public_path__ + "static/media/GZ-Logo.40d03921.png";